var render, staticRenderFns
import script from "./KDragContainer.vue?vue&type=script&lang=js&"
export * from "./KDragContainer.vue?vue&type=script&lang=js&"
import style0 from "./KDragContainer.vue?vue&type=style&index=0&id=9da51488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da51488",
  null
  
)

export default component.exports